import { jsx as h } from "react/jsx-runtime";
/* empty css            */
import { useContext as T, createContext as l, useState as f, useEffect as d } from "react";
import { COLOR_PRIMITIVES as g } from "./index.es648.js";
import { CORNER_RADIUS as u } from "./index.es649.js";
import { SPACINGS as E } from "./index.es650.js";
import { applyThemeToRoot as R, applySpacingsToRoot as I, applyCornerRadiusToRoot as y, applyZIndexesToRoot as D } from "./index.es651.js";
import { Z_INDEXES as x } from "./index.es174.js";
import { LIGHT_A11Y_THEME as _ } from "./index.es652.js";
import { DARK_A11Y_THEME as M } from "./index.es653.js";
import { DARK_THEME as v } from "./index.es654.js";
import { LIGHT_THEME as C } from "./index.es655.js";
import { getCategorical as P } from "./index.es656.js";
import { getTrafficVolumePalettesDictionary as A } from "./index.es50.js";
import { getTradeAreaPalettesDictionary as H } from "./index.es51.js";
import { getHeatMapPalettesDictionary as S } from "./index.es49.js";
import { getDivergingPalettesDictionary as k } from "./index.es48.js";
import { getDemographicPalettesDictionary as L } from "./index.es47.js";
const r = {
  light: C,
  dark: v,
  "dark-a11y": M,
  "light-a11y": _
}, s = {
  primitives: g,
  themes: r,
  spacings: E,
  cornerRadius: u,
  zIndexes: x,
  getDemographicPalettesDictionary: L,
  getDivergingPalettesDictionary: k,
  getHeatMapPalettesDictionary: S,
  getTradeAreaPalettesDictionary: H,
  getTrafficVolumePalettesDictionary: A,
  getCategorical: P,
  setThemes: (t) => console.warn("setThemes was called outside of ThemeProvider context"),
  activeTheme: { themeMode: "light", theme: r.light }
}, a = l(s), W = () => T(a), $ = ({ children: t, mode: n = "light" }) => {
  const [o, c] = f(n), p = (m) => {
    m.includes("dark") && console.warn(
      "Currently there is no dark theme, this is preparation for the future, all dark themes are copies of their light counterparts"
    ), c(m);
  }, i = r[o], e = {
    ...s,
    setThemes: p,
    activeTheme: { themeMode: o, theme: i }
  };
  return d(() => {
    R(e.activeTheme.theme), I(e.spacings), y(e.cornerRadius), D(e.zIndexes);
  }, [
    o,
    i,
    e.activeTheme.theme,
    e.spacings,
    e.cornerRadius,
    e.zIndexes
  ]), /* @__PURE__ */ h(a.Provider, { value: e, children: t });
};
export {
  $ as ThemeProvider,
  W as useTheme
};
//# sourceMappingURL=index.es173.js.map
